import * as React from "react";
import type { SVGProps } from "react";
const SvgRocketship = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    fill="none"
    {...props}
  >
    <path
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="m6.922 27.174 20.65 20.574a5 5 0 0 0 7.043.015L46.977 35.55a5 5 0 0 0 .013-7.1L32.5 14.03C22.15 1.696 10.499.789 4.226 2.209c-1.493.338-2.592 1.568-2.858 3.075-1.691 9.57 2.859 18.44 5.555 21.89Z"
    />
    <path
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="m14.25 48.228-.152-1.216c-.593-4.72 5.118-7.523 8.489-4.167l1.694 1.687a5 5 0 0 1 1.472 3.543v1.05c0 4.44-5.353 6.677-8.512 3.56L15.7 51.162a4.999 4.999 0 0 1-1.45-2.935ZM46.14 13.877l-1.282-.15c-4.694-.553-7.463 5.113-4.143 8.477l1.795 1.82a5 5 0 0 0 3.667 1.486l1.148-.025c4.415-.095 6.548-5.447 3.41-8.553l-1.662-1.643a5 5 0 0 0-2.932-1.412Z"
    />
    <path
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="m50.275 44.016-7.149 7.326a4.234 4.234 0 1 1-6.006-5.97l7.282-7.193a4.14 4.14 0 0 1 5.873 5.837Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M46.308 55.067v8.827M56.339 45.839l8.661 1.7M50.722 50.653l11.234 13.642"
    />
    <circle
      cx={15.014}
      cy={16.55}
      r={4.341}
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.75}
    />
  </svg>
);
export default SvgRocketship;
